import { render, staticRenderFns } from "./RecommendationPedidosHistorico.vue?vue&type=template&id=59d5b40f"
import script from "./RecommendationPedidosHistorico.vue?vue&type=script&lang=js"
export * from "./RecommendationPedidosHistorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports